import React, { useEffect, useState, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../../api';

export default function BOInventory() {
  const { standId } = useParams();
  const [products, setProducts] = useState([]);

  const fetchProducts = useCallback(() => {
    api.getStandProducts(standId).then(setProducts);
  }, [standId]);

  useEffect(() => { fetchProducts(); }, [fetchProducts]);

  const handleToggle = async (productId) => {
    await api.toggleProduct(productId);
    fetchProducts();
  };

  // Grouper par categorie
  const categories = {};
  products.forEach(p => {
    if (!categories[p.categorie]) categories[p.categorie] = [];
    categories[p.categorie].push(p);
  });

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-serif text-[#332A1C] text-2xl">Inventaire rapide</h1>
        <Link
          to={`/backoffice/${standId}/product/new`}
          className="bg-[#C4673D] text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-[#C4673D]/90 transition"
        >
          + Nouveau produit
        </Link>
      </div>

      {Object.entries(categories).map(([cat, prods]) => (
        <div key={cat} className="mb-6">
          <h2 className="text-xs font-bold text-[#8B7355] uppercase tracking-wider mb-3">{cat}</h2>
          <div className="bg-white rounded-xl shadow-sm divide-y divide-[#E2D1B8]/50">
            {prods.map(product => (
              <div key={product.id} className="p-4 flex items-center justify-between">
                <div className="flex-1">
                  <Link
                    to={`/backoffice/${standId}/product/${product.id}`}
                    className="font-medium text-[#332A1C] hover:text-[#C4673D] transition-colors"
                  >
                    {product.nom}
                  </Link>
                  <p className="text-sm text-[#8B7355] mt-0.5">{product.prix_ttc.toFixed(2)} &euro; TTC</p>
                </div>
                <button
                  onClick={() => handleToggle(product.id)}
                  className={`relative w-14 h-8 rounded-full transition-colors ${product.disponible ? 'bg-[#6B7F3B]' : 'bg-red-400'}`}
                >
                  <span className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow transition-transform ${product.disponible ? 'left-7' : 'left-1'}`} />
                </button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
